// components/employer/SendNotificationModal.jsx
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import axios from 'axios';

const SendNotificationModal = ({ isOpen, onClose, application }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    type: '',
    title: '',
    message: '',
  });

  const types = [
    { value: 'shortlisted', label: 'Shortlisted for Interview' },
    { value: 'interview_invitation', label: 'Interview Invitation' },
    { value: 'rejected', label: 'Application Rejected' },
    { value: 'offer', label: 'Job Offer' },
    { value: 'hired', label: 'Congratulations - Hired!' },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}notification/create`,
        {
          recipient: application.jobSeeker._id,
          application: application._id,
          type: form.type,
          title: form.title || types.find(t => t.value === form.type)?.label,
          message: form.message,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        }
      );

      toast.success('Notification / Letter sent successfully');
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send letter');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6 md:p-8">
          <h2 className="text-2xl font-bold mb-6 text-gray-800">
            Send Notification Letter
          </h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium mb-1.5">Type of Letter</label>
              <select
                value={form.type}
                onChange={e => setForm({ ...form, type: e.target.value })}
                required
                className="w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-orange-500"
              >
                <option value="">Select letter type...</option>
                {types.map(t => (
                  <option key={t.value} value={t.value}>{t.label}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1.5">Title</label>
              <input
                type="text"
                value={form.title}
                onChange={e => setForm({ ...form, title: e.target.value })}
                placeholder="e.g. Invitation to Interview"
                className="w-full px-4 py-2.5 border rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1.5">Message / Letter Content</label>
              <textarea
                rows={8}
                value={form.message}
                onChange={e => setForm({ ...form, message: e.target.value })}
                required
                className="w-full px-4 py-3 border rounded-lg resize-none focus:ring-2 focus:ring-orange-500"
                placeholder="Write your letter here..."
              />
            </div>

            <div className="flex justify-end gap-4 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-2.5 border rounded-lg hover:bg-gray-100"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-6 py-2.5 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:opacity-60"
              >
                {loading ? 'Sending...' : 'Send Letter'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SendNotificationModal;